<div class="invoice d-flex flex-column ws-flex-auto min-height-0 isolate">
    <ws-bread-crumbs [breadcrumbs]="breadcrumbs" currentPageTitle="Invoice"></ws-bread-crumbs>
    <div class="ws-section">
        <div class="ws-section__header">
            <h4 class="ws-section__header__title page-title">Invoice</h4>
            @if (!(loading || callInProgress) && currentInvoice) {
                <div class="ws-section__header__actions">
                    @if (!editMode && !taskOnlyEditMode) {
                        <div class="ws-section__header__actions__item">
                            <button type="button"
                                    class="ace-btn btn-sm has-icon btn-primary"
                                    data-qa="invoice-edit"
                                    helpTooltip
                                    helpContentId="app.edit"
                                    (click)="setEditMode()">
                                <i class="fa fa-pencil"></i>
                            </button>
                        </div>
                    }
                    @if (editMode || taskOnlyEditMode) {
                        <div class="ws-section__header__actions__item">
                            <button type="button"
                                    class="ace-btn btn-sm has-icon btn-secondary btn-danger"
                                    data-qa="invoice-delete"
                                    helpTooltip
                                    helpContentId="app.delete"
                                    (click)="delete()"
                                    [disabled]="callInProgress || loading || !currentInvoice || !currentInvoice.canBeDeleted">
                                <i class="fa fa-trash"></i>
                            </button>
                        </div>
                    }
                    @if (editMode && showCompleteButton || taskList) {
                        <div class="ws-section__header__actions__item">
                            @if (showCompleteButton) {
                                <button type="button"
                                        [disabled]="callInProgress || loading"
                                        data-qa="invoice-complete"
                                        (click)="complete()"
                                        class="ace-btn btn-sm btn-secondary">{{ completeText }}
                                </button>
                            }
                            @if (taskList) {
                                <button type="button"
                                        [tooltip]="closeText + ' Invoice'"
                                        data-qa="invoice-skip"
                                        [disabled]="callInProgress || loading"
                                        (click)="skipInvoice()"
                                        class="ace-btn btn-sm btn-primary">{{ closeText }}
                                </button>
                            }
                        </div>
                    }
                    @if (editMode || taskOnlyEditMode) {
                        <div class="ws-section__header__actions__item">
                            <button type="button"
                                    [disabled]="callInProgress || loading"
                                    helpTooltip
                                    helpContentId="app.save"
                                    data-qa="invoice-save"
                                    (click)="save()"
                                    class="ace-btn btn-sm has-icon btn-primary">
                                <i class="fa fa-save"></i>
                            </button>
                            <button type="button"
                                    class="ace-btn btn-sm has-icon btn-primary btn-danger"
                                    data-qa="invoice-cancel"
                                    helpTooltip
                                    helpContentId="app.cancel"
                                    (click)="cancelEdit()">
                                <i class="fa fa-close"></i>
                            </button>
                        </div>
                    }
                </div>
            }
        </div>
    </div>
    <div class="d-flex flex-column flex-grow-1 min-height-0 bg-white py-3 px-2 ace-radius position-relative">
        @if (loading || !currentInvoice) {
            <ws-ace-loader [hideLabel]="false"></ws-ace-loader>
        }
        @if (currentInvoice) {
            <div>
                <div class="invoice-grid px-2 mt-2">
                    <div class="invoice-items">
                        <label for="contractType">Contract Type:</label>
                        <div>
                            @if (!editMode || !canChangeContractType) {
                                <span
                                    data-qa="invoice-contractType"
                                    [ngClass]="{'overridden': currentInvoice.contractServiceType !== currentInvoice.defaultContractServiceType}">
                                    {{ invoiceService.contractServiceName(currentInvoice.contractServiceType) }}
                                </span>
                            }
                            @if (currentInvoice.contractServiceType === ContractServiceType.Appeal && currentInvoice.isAdHoc) {
                                <span> (ad hoc)</span>
                            }
                            @if (editMode && canChangeContractType) {
                                <select [(ngModel)]="currentInvoice.contractServiceType"
                                        data-qa="invoice-contractType-select"
                                        (ngModelChange)="onContractServiceTypeChange()"
                                        class="form-select form-select-sm">
                                    @for (type of appealContractTypes; track type) {
                                        <option [value]="type.value">{{ type.name }}</option>
                                    }
                                </select>
                            }
                        </div>

                        <label for="dueDate">RIBS Due Date:</label>
                        <weissman-datetime [readOnly]="!editMode"
                                           data-qa="invoice-dueDate"
                                           [dateOnly]="true"
                                           [(inputDate)]="currentInvoice.dueDate">
                        </weissman-datetime>

                        @if (enableInvoiceUBR && (currentInvoice.isUBR || currentInvoice.invoiceUBRNumber)) {
                            <label for="invoiceUBRNumber">UBR Request #:</label>
                            @if (currentInvoice.invoiceUBRNumber) {
                                <span data-qa="invoice-ubrNumber">{{ currentInvoice.invoiceUBRNumber }}</span>
                            } @else {
                                <span data-qa="invoice-ubrNumber">Draft</span>
                            }
                        }

                        <label for="invoiceNumber">RIBS Request #:</label>
                        @if (currentInvoice.invoiceNumber) {
                            <span data-qa="invoice-invoiceNumber">{{ currentInvoice.invoiceNumber }}</span>
                        } @else {
                            <span data-qa="invoice-invoiceNumber">Draft</span>
                        }

                        <label for="taskStatus">Status:</label>
                        <a style="cursor: pointer"
                           data-qa="invoice-taskStatus"
                           (click)="launchTaskModal()">{{ currentInvoice.taskSummary[0].status }}</a>

                        <label for="ubr">UBR:</label>
                        <ws-switch [(ngModel)]="currentInvoice.isUBR"
                                   data-qa="invoice-ubr"
                                   (ngModelChange)="setButtonText()"
                                   [disabled]="!editMode">
                        </ws-switch>

                        @if (isRyanLegalServiceEnabled) {
                            <label for="rls">RLS:</label>
                            <ws-switch [(ngModel)]="currentInvoice.isRyanLegalServices"
                                       data-qa="invoice-rls"
                                       (ngModelChange)="onIsRyanLegalServicesChanged()"
                                       [disabled]="!editMode">
                            </ws-switch>
                        }
                    </div>
                    <div class="invoice-items">
                        <label for="company">Company:</label>
                        <span>
                            <a anchor-route
                               data-qa="invoice-company"
                               [sref]="{ target: 'company', options: { companyId: currentInvoice.companyId } }"
                               [isTargetBlank]="true"
                               rel="noreferrer">
                                {{ currentInvoice.companyName }}
                            </a>
                        </span>

                        <label for="accountHandler">Account Handler:</label>
                        <span
                            data-qa="invoice-accountHandler">{{ currentInvoice.accountHandler.firstName }} {{ currentInvoice.accountHandler.lastName }}</span>

                        @if (currentInvoice.taxSavings?.length > 0) {
                            <label for="taxYear">Tax Year:</label>
                            <span data-qa="invoice-tax-year">{{ currentInvoice.annualYear }}</span>
                        }

                        @if (currentInvoice.siteId) {
                            <label for="siteStName">Site ST-Name:</label>
                            <span>
                                <a anchor-route
                                   data-qa="invoice-site"
                                   [sref]="{ target: 'site', options: {companyId: currentInvoice.companyId, siteId: currentInvoice.siteId} }"
                                   [isTargetBlank]="true"
                                   rel="noreferrer">
                                    {{ currentInvoice.siteState.abbr }} - {{ currentInvoice.siteName }}
                                </a>
                            </span>
                        }

                        @if (currentInvoice.taxSavings?.length > 0) {
                            <label for="company">Appeal Level:</label>
                            <span data-qa="invoice-appeal-level">{{ currentInvoice.appeals[0]?.appealLevelAbbr }}</span>
                        }

                        <label for="invoiceRecipientLookup">Recipient:</label>
                        <invoice-recipient-lookup #invoiceRecipientLookup
                                                  [editMode]="editMode"
                                                  [invoice]="currentInvoice">
                        </invoice-recipient-lookup>

                        <label class="mt-2" for="approvalDate">Third Party Approval
                            Date:</label>
                        <weissman-datetime class="mt-2"
                                           data-qa="invoice-approval-date"
                                           [readOnly]="!editMode"
                                           [dateOnly]="true"
                                           [(inputDate)]="currentInvoice.thirdPartyApprovalDate"
                                           helpTooltip
                                           tooltipText="Latest appeal savings date when type is Appeal, otherwise current date."
                                           position="right">
                        </weissman-datetime>
                    </div>
                    <div>
                        <div class="large-block">
                            <div class="d-flex justify-content-between">
                                <label style="width: 150px;" for="processingInstructions">Processing
                                    Instructions: </label>
                                <div>
                                    <entity-attachments buttonClass="has-icon"
                                                        [modalData]="attachmentData"
                                                        [(hasAttachments)]="currentInvoice.hasAttachments"
                                                        (allAttachmentsChange)="allAttachments($event)"
                                                        (isCustomOrderingEnabledChange)="onCustomOrderingEnabledChange($event)"
                                                        (entityRowVersionChange)="onAttachmentEntityRowVersionChange($event)">
                                    </entity-attachments>
                                    <entity-comments buttonClass="has-icon"
                                                     [modalData]="commentData"
                                                     [(hasComments)]="currentInvoice.hasComments"
                                                     (hasCommentsChange)="currentInvoice.hasComments = $event">
                                    </entity-comments>
                                </div>
                            </div>
                            <textarea class="form-control w-100"
                                      data-qa="invoice-processing-instructions"
                                      style="height: 80px; z-index: 2;"
                                      [disabled]="!editMode"
                                      [(ngModel)]="currentInvoice.processingInstructions">
                            </textarea>
                        </div>
                        <label class="mb-0" for="contractTerms">Terms:</label>
                        <hr class="mt-0 mb-2">
                        @if (editMode && companyAppealContractTerms.length > 1) {
                            <select name="terms"
                                    data-qa="invoice-terms-select"
                                    [(ngModel)]="currentContractTermDetailId"
                                    (ngModelChange)="onContractTermChange($event)"
                                    class="form-select form-select-sm">
                                @for (term of companyAppealContractTerms; track term; let i = $index) {
                                    <option [value]="term.contractTermDetailId"
                                            [attr.data-qa]="'invoice-terms-select-' + i">
                                        <term-rates-and-fees [term]="term"
                                                             [usePercent]="true">
                                        </term-rates-and-fees>
                                    </option>
                                }
                            </select>
                        }
                        @if (!editMode || companyAppealContractTerms.length <= 1) {
                            <div class="d-flex justify-content-between"
                                 [class.overridden]="isContractTermOverridden">
                                <term-rates-and-fees [term]="contractTerm"
                                                     [usePercent]="true">
                                </term-rates-and-fees>
                                @if (currentInvoice.contractTermDetailRemarks) {
                                    <button
                                        class="ace-btn has-icon"
                                        triggers="mouseenter:mouseleave"
                                        data-qa="invoice-terms-remarks"
                                        [popover]="currentInvoice.contractTermDetailRemarks">
                                        <i class="fa fa-commenting"></i>
                                    </button>
                                }
                            </div>
                        }
                    </div>
                </div>
                <!-- INVOICE DETAILS COMPONENT -->
                @if (currentInvoice.taxSavings?.length === 0) {
                    <invoice-details-old [currentInvoice]="currentInvoice"
                                         [editMode]="editMode"
                                         [loading]="loading"
                                         [cachedInvoice]="cachedInvoice">
                    </invoice-details-old>
                } @else {
                    <invoice-details [(currentInvoice)]="currentInvoice"
                                     [editMode]="editMode"
                                     [(loading)]="loading"
                                     [cachedInvoice]="cachedInvoice">
                    </invoice-details>
                }
                <!-- FEE ALLOCATION COMPONENT -->
                <fee-allocation [currentInvoiceAmount]="currentInvoice.invoiceAmount"
                                [currentInvoice]="currentInvoice"
                                [editMode]="editMode"
                                (engagementChanged)="invoiceRecipientLookup.getRecipientList()">
                </fee-allocation>
            </div>
        }
    </div>
</div>

